import { isPointGeometry, PointGeometry } from "./PointGeometry";

export interface Address {
    address : string;
    propId : number;
    GURASID : string;
    geometry : PointGeometry;
}

export function isAddress(object: any) : object is Address {	
    return 'address' in object && 
        'propId' in object &&
		'GURASID' in object;
}
